
import Ajax from '../js/common/ajax';
/**
  * 首页接口
  */
export default {
	voucherCount() {
		return Ajax.get("/home/voucher/count")
	},
	chart: {
		revenueProfit() {
			return Ajax.get("/home/chart/revenueProfit")
		},
		cost() {
			return Ajax.get("/home/chart/cost")
		},
		cash() {
			return Ajax.get("/home/chart/cash")
		}
	}
}